/**
 * @file
 * Blog Block script.
 */

(function blogBlockScript($, Drupal) {
  'use strict';
  Drupal.behaviors.blogBlockTout = {
    attach: function (context) {
      var $blogBlock = $('.blog-block--with-tout', context);
      var $blogBlockItems = $('.blog-block__item', $blogBlock);
      var $itemTout = $('.blog-block__item--tout', $blogBlock);
      // zero-based indexing
      var orderSmall = $itemTout.attr('data-order-small') - 1;
      var orderLarge = $itemTout.attr('data-order-large') - 1;

      // Clone & insert the text tout in the desired "order"
      // for mobile 2-up and for tablet/desktop 4-up grids.
      $blogBlockItems.each(function (index, element) {
        switch (index) {
          // -- mobile position
          case orderSmall:
            $itemTout
              .clone()
              .removeAttr('data-order-large')
              .insertAfter(element);
            break;
          // -- tablet/desktop position
          case orderLarge:
            $itemTout
              .clone()
              .removeAttr('data-order-small')
              .insertAfter(element);
            break;
        }
        // Detach the original tout.
        $itemTout.detach();
      });
    }
  };
}(jQuery, Drupal));
